import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

import "./bottom_nav.css";

const TABS = [
  {
    key: "home",
    to: "/",
    exact: true,
    match: (p) => p === "/",
    path: "M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z",
  },
  {
    key: "calendars",
    to: "/calendar/monthly",
    match: (p) => p.startsWith("/calendar") || p.startsWith("/grid"),
    path: "M19 4h-1V2h-2v2H8V2H6v2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm0 16H5V9h14v11z",
  },
  {
    key: "create",
    to: "/post/new_post",
    match: (p) => p.startsWith("/post/"),
    primary: true,
    path: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z",
  },
  {
    key: "engage",
    to: "/engage",
    match: (p) => p.startsWith("/engage"),
    path: "M20 2H4a2 2 0 0 0-2 2v18l4-4h14a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zM6 9h12v2H6V9zm8 5H6v-2h8v2zm4-6H6V6h12v2z",
  },
  {
    key: "library",
    label: "library_short",
    to: "/library",
    match: (p) => p.startsWith("/library"),
    path: "M22 16V4a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2zm-11-4l2.03 2.71L16 11l4 5H8l3-4zM2 6v14a2 2 0 0 0 2 2h14v-2H4V6H2z",
  },
];

const BottomNav = () => {
  const { t } = useTranslation(["sidebar"]);
  const { pathname } = useLocation();

  return (
    <nav className="bottom-nav" aria-label="Main">
      {TABS.map((tab) => {
        const active = tab.match(pathname);
        return (
          <NavLink
            key={tab.key}
            to={tab.to}
            exact={tab.exact}
            className={
              "bottom-nav-item" +
              (active ? " active" : "") +
              (tab.primary ? " primary" : "")
            }
            aria-current={active ? "page" : undefined}
          >
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path d={tab.path} />
            </svg>
            <span>{t(tab.label || tab.key)}</span>
          </NavLink>
        );
      })}
    </nav>
  );
};

export default BottomNav;
